import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Button, ConfirmationModal, Typography } from 'seagull';
import { OpenTab } from 'seagull/icons';
import { CopyToClipboard } from '~/components/CopyToClipboard/CopyToClipboard';
import { openInNewTabProps } from '~/constants';
import { useEventReporter, useOverlayContext, useStoreActions } from '~/contexts';
import { useOnMount } from '~/hooks/useOnMount';
import { useLocaleKeys } from '~/i18n';
import styles from '../CopyAPIKeyModal/CopyAPIKeyModal.module.scss';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import ZapierLogo from './ZapierLogo';
function ZapierIntegrateModal(param) {
    let { dismissModal, getApiKey, onCopyApiKey } = param;
    const { t: texts } = useLocaleKeys('integrations.availableApps.zapier');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { t: commonTexts } = useLocaleKeys('common');
    const [apiKey, setApiKey] = useState('');
    const [helperText, setHelperText] = useState('');
    useOnMount(()=>{
        getApiKey().then(setApiKey).catch(()=>setHelperText(sharedTexts.apiKeyNotFound()));
    });
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'zapier_card_confirm'
            },
            secondaryButton: {
                name: 'zapier_card_cancel'
            }
        },
        title: texts.title(),
        width: "760px",
        content: /*#__PURE__*/ _jsxs("div", {
            className: styles.modalContainer,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.integrateSteps()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.step1()
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.copyApiKeyContainer,
                    children: /*#__PURE__*/ _jsx(CopyToClipboard, {
                        testId: "zapier-api-key",
                        value: apiKey,
                        helperText: helperText,
                        error: !!helperText,
                        onClick: onCopyApiKey
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.stepsContainer,
                    children: /*#__PURE__*/ _jsx(Typography, {
                        children: texts.step2()
                    })
                }),
                /*#__PURE__*/ _jsx(Button, _object_spread_props(_object_spread({
                    bi: {
                        name: 'go_to_zapier'
                    },
                    skin: "primaryOutline",
                    testId: "go-to-zapier",
                    as: "a",
                    suffixIcon: /*#__PURE__*/ _jsx(OpenTab, {}),
                    href: "https://zapier.com/app/connections"
                }, openInNewTabProps), {
                    className: styles.goToContainer,
                    children: texts.goToZapier()
                }))
            ]
        }),
        primaryButtonLabel: commonTexts.buttons.close(),
        onPrimaryButtonClick: dismissModal,
        onCloseButtonClick: dismissModal,
        testId: "integrate-with-zapier-modal"
    });
}
export default function ZapierCard() {
    const { t: zapierTexts } = useLocaleKeys('integrations.availableApps.zapier');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { api } = useStoreActions();
    const { reportToAppcues, reportToGtm, reportToHeap, reportToHubspot } = useEventReporter();
    const overlayContext = useOverlayContext();
    const { logBI } = useStoreActions();
    const openIntegrateModal = ()=>{
        logBI(12050);
        reportToAppcues('button-click', "zapier-vendor-clicked-connect");
        reportToGtm('button-click', "zapier-vendor-clicked-connect");
        reportToHeap('integrations', 'click', "zapier-connect");
        reportToHubspot("vendor_clicked_connect_to_zapier");
        overlayContext.showModal({
            biName: 'zapier_integrate_modal',
            closeOnEscapeKey: true,
            closeOnClickOutside: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ZapierIntegrateModal, {
                    dismissModal: dismissModal,
                    getApiKey: ()=>api.zapier.getApiKey(),
                    onCopyApiKey: ()=>{
                        logBI(12051);
                        reportToAppcues('button-click', "zapier-vendor-copied-api-key-to-clipboard");
                        reportToGtm('button-click', "zapier-vendor-copied-api-key-to-clipboard");
                        reportToHeap('integrations', 'click', "zapier-copy-api-key");
                        reportToHubspot('vendor_copied_api_key_to_clipboard');
                    }
                });
            }
        });
    };
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "zapier-card",
        icon: /*#__PURE__*/ _jsx(ZapierLogo, {}),
        title: zapierTexts.title(),
        subTitle: zapierTexts.subtitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_zapier'
            },
            onClick: openIntegrateModal,
            testId: "zapier-card-connect",
            children: sharedTexts.connectButton()
        })
    });
}
